






















import mixins from 'vue-typed-mixins';
import { Location } from 'vue-router';

export default mixins().extend({
  computed: {
    tabs(): any {
      return [
        {
          text: this.$i18n.tc('model.deployment.version.label', 2),
          location: { name: 'version' },
        },
        {
          text: this.$i18n.tc('model.deployment.contactInfo.label', 2),
          location: { name: 'contact-info-edit' },
        },
      ];
    },

    tab(): undefined | number {
      return this.tabs?.findIndex(
          (tab: any) => this.$route.name === tab.location.name
      );
    },
  },

  methods: {
    async navigate(location: Location) {
      if (
          typeof location === 'string'
              ? this.$route.path !== location
              : this.$route.name !== location.name
      ) {
        let allowNavigation = true;
        if (allowNavigation) {
          await this.$router.push(location);
        }
      }
    },
  },
});
